/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListAPIKeysRequest,
  ListAPIKeysSecurity,
} from "../models/operations/listapikeys.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildListAPIKeysQuery,
  ListAPIKeysQueryData,
  prefetchListAPIKeys,
  queryKeyListAPIKeys,
} from "./listAPIKeys.core.js";
export {
  buildListAPIKeysQuery,
  type ListAPIKeysQueryData,
  prefetchListAPIKeys,
  queryKeyListAPIKeys,
};

export type ListAPIKeysQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listKeys keys
 *
 * @remarks
 * List all api keys for an organization
 */
export function useListAPIKeys(
  request?: ListAPIKeysRequest | undefined,
  security?: ListAPIKeysSecurity | undefined,
  options?: QueryHookOptions<ListAPIKeysQueryData, ListAPIKeysQueryError>,
): UseQueryResult<ListAPIKeysQueryData, ListAPIKeysQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildListAPIKeysQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listKeys keys
 *
 * @remarks
 * List all api keys for an organization
 */
export function useListAPIKeysSuspense(
  request?: ListAPIKeysRequest | undefined,
  security?: ListAPIKeysSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    ListAPIKeysQueryData,
    ListAPIKeysQueryError
  >,
): UseSuspenseQueryResult<ListAPIKeysQueryData, ListAPIKeysQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildListAPIKeysQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setListAPIKeysData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      agentId?: string | undefined;
      gramSession?: string | undefined;
    },
  ],
  data: ListAPIKeysQueryData,
): ListAPIKeysQueryData | undefined {
  const key = queryKeyListAPIKeys(...queryKeyBase);

  return client.setQueryData<ListAPIKeysQueryData>(key, data);
}

export function invalidateListAPIKeys(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      agentId?: string | undefined;
      gramSession?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "keys", "list", ...queryKeyBase],
  });
}

export function invalidateAllListAPIKeys(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "keys", "list"],
  });
}
